import { gridDefaults } from "@serenity-is/sleekgrid";

// Disable HTML rendering in all SleekGrid's by default to enhance security
gridDefaults.enableHtmlRendering = false;